export const FETCH_SUMMARIES_REPORT_BEGIN = 'FETCH_SUMMARIES_REPORT_BEGIN';
export const FETCH_SUMMARIES_REPORT_SUCCESS = 'FETCH_SUMMARIES_REPORT_SUCCESS';
export const FETCH_SUMMARIES_REPORT_ERROR = 'FETCH_SUMMARIES_REPORT_ERROR';
export const UPDATE_SUMMARY_REPORT = 'UPDATE_SUMMARY_REPORT';
export const AUTHORIZE_WEEKLY_SUMMARY_REPORTS = 'AUTHORIZE_WEEKLY_SUMMARY_REPORTS';
export const AUTHORIZE_WEEKLYSUMMARIES_REPORTS_ERROR = 'AUTHORIZE_WEEKLYSUMMARIES_REPORTS_ERROR';
export const SAVE_WEEKLY_SUMMARIES_RECIPIENTS = 'SAVE_WEEKLY_SUMMARIES_RECIPIENTS';
export const DELETE_WEEKLY_SUMMARIES_RECIPIENTS = 'DELETE_WEEKLY_SUMMARIES_RECIPIENTS';
export const GET_SUMMARY_RECIPIENTS = 'GET_SUMMARY_RECIPIENTS';
export const GET_SUMMARY_RECIPIENTS_ERROR = 'GET_SUMMARY_RECIPIENTS_ERROR';
